import * as Blockly from 'blockly/core'
import { Msg } from 'blockly'


const createBlockStyle = (primary, secondary, tertiary) => ({
    colourPrimary: primary,
    colourSecondary: secondary,
    colourTertiary: tertiary,
});

// Updated palette: softer, more layered, and closer to the Lego Spike feel.
Msg.MOVEMENT_HEX = "#2563eb";
Msg.OBJECTS_HEX = "#22c55e";
Msg.LOGIC_HEX = "#f59e0b";
Msg.EXTRAS_HEX = "#fb7185";
Msg.MATH_HEX = "#6366f1";
Msg.EXAMPLES_HEX = '#64748b';
Msg.STRUCTURE_HEX = '#94a3b8';


// Reference: https://blocklycodelabs.dev/codelabs/theme-extension-identifier/index.html#0
Blockly.Themes.Rocksi = Blockly.Theme.defineTheme('rocksi', {
    'base': Blockly.Themes.Modern,
    'blockStyles': {
        'movement_blocks': createBlockStyle('#2563eb', '#dbeafe', '#1d4ed8'),

        'objects_blocks': createBlockStyle('#22c55e', '#dcfce7', '#16a34a'),
        'colour_blocks': createBlockStyle('#22c55e', '#dcfce7', '#16a34a'),

        'logic_blocks': createBlockStyle('#f59e0b', '#fef3c7', '#d97706'),
        'loop_blocks': createBlockStyle('#f59e0b', '#fef3c7', '#d97706'),

        'extras_blocks': createBlockStyle('#fb7185', '#ffe4e6', '#e11d48'),

        'examples_blocks': createBlockStyle('#64748b', '#e2e8f0', '#475569'),

        'structure_blocks': createBlockStyle('#94a3b8', '#e2e8f0', '#64748b'),

        'math_blocks': createBlockStyle('#6366f1', '#e0e7ff', '#4f46e5'),
    },
    'categoryStyles': {
        'movement_category': {
            'colour': Msg.MOVEMENT_HEX,
        },
        'objects_category': {
            'colour': Msg.OBJECTS_HEX,
        },
        'logic_category': {
            'colour': Msg.LOGIC_HEX,
        },
        'extras_category': {
            'colour': Msg.EXTRAS_HEX,
        },
        'examples_category': {
            'colour': Msg.EXAMPLES_HEX,
        },
    },
    'componentStyles': {
        'workspaceBackgroundColour': '#f7fafc',
        'toolboxBackgroundColour': '#f8fbff',
        'toolboxForegroundColour': '#1f2937',
        'flyoutBackgroundColour': '#ffffff',
        'flyoutForegroundColour': '#111827',
        'flyoutOpacity': 1,
        'scrollbarColour': '#94a3b8',
        'scrollbarOpacity': 0.6,
        'cursorColour': '#1f2937',
        'insertionMarkerColour': '#1d4ed8',
        'insertionMarkerOpacity': 0.18,
        'selectedGlowColour': 'transparent',
        'selectedGlowSize': 0.01,
        'replacementGlowColour': 'transparent',
        'replacementGlowSize': 0.01,
    },
    'fontStyle': {
        'family': 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        'size': 12,
        'weight': '400',
    },
});
